import 'css-chunksrc/client/pages/projectPage/resourcesPage/groupsList/skeletonDisplay/styles.scss';export default {
  "group": "_group_1qfw2_1",
  "groupHeader": "_groupHeader_1qfw2_5",
  "name": "_name_1qfw2_15",
  "members": "_members_1qfw2_19",
  "resourcesList": "_resourcesList_1qfw2_23",
  "list": "_list_1qfw2_30",
  "elem": "_elem_1qfw2_39"
};